const CONSTANTS = {
    NOT_MEMBER: 'NOT_MEMBER',
    CAN_NOT_BID: 'CAN_NOT_BID',
    CAN_BID: 'CAN_BID',
    AUCTION_STATE_PENDING : '1', //非公開
    AUCTION_STATE_OPEN : '2', //予定公開
    AUCTION_STATE_RELEASE : '3', //出品表公開
    AUCTION_STATE_PREBID : '4', //事前入札中
    AUCTION_STATE_PREBID_END : '5', //事前入札終了
    AUCTION_STATE_STARTED : '6', //開催中
    AUCTION_STATE_END : '7', //開催終了
    AUCTION_CLASSIFICATION_ONLINE : '1',
    AUCTION_CLASSIFICATION_LIVE : '2',
    AUCTION_CLASSIFICATION_LIVE_HALL : '3',
    AUCTION_IS_PREBID : '1',
    AUCTION_IS_NOT_PREBID : '0',
    PRODUCT_AUTO_END_TIME_EXTENSION: '1',
};

export default CONSTANTS;
